import { alpha, makeStyles, Theme } from "@material-ui/core"

export const useStyles = makeStyles((theme: Theme) => ({
  alert: {
    background: theme.palette.background.paper,
  },
  deleteAccountButton: {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    "&:hover": {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.common.white,
      borderColor: theme.palette.error.main,
    },
  },
  deleteAccountDialogContent: {
    marginBottom: theme.spacing(2),
  },

  deleteAccountDialogFooter: {
    padding: theme.spacing(2),
    "& .MuiTextField-root": {
      marginBottom: theme.spacing(),
    },
    "& fieldset": {
      borderColor: theme.palette.common.black,
    },
    "& button": {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.error.main,
      "&:hover": {
        backgroundColor: theme.palette.error.main,
      },
    },
  },
  deleteAccountDialogAlert: {
    color: theme.palette.common.black,
    marginBottom: theme.spacing(2),
    background: alpha(theme.palette.warning.main, 0.4),
    "& .MuiAlert-icon": {
      fontSize: 16,
      color: theme.palette.common.black,
    },
  },
  deleteAccountDialogCloseButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.text.secondary,
  },

  userInfoSection: {
    marginBottom: theme.spacing(2),
  },

  deleteSuccessDialogText: {
    marginBottom: theme.spacing(2),
  },
}))
